import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ScoreBadge } from "@/components/Chips";

export const FixFirst = ({ items }) => (
  <section data-testid="fix-first-list" className="rounded-2xl border glass p-5 sm:p-6 h-fit xl:sticky xl:top-12">
    <h2 className="text-xl font-medium">Fix these first</h2>
    <p className="mt-1 text-sm text-muted-foreground">Lowest scores with the least traffic at risk. Protected bestsellers are left out.</p>
    <ol className="mt-5 divide-y">
      {items.map((l, i) => (
        <li key={l.id}>
          <Link
            to={`/app/listings/${l.id}`}
            data-testid={`fix-first-item-${l.id}`}
            className="group flex items-start gap-3 py-3 transition-colors hover:bg-secondary/50 -mx-2 px-2 rounded-lg"
          >
            <span className="w-5 pt-0.5 font-mono text-xs text-muted-foreground">{i + 1}</span>
            <span className="flex-1 min-w-0">
              <span className="block truncate text-sm">{l.title}</span>
              <span className="text-xs text-muted-foreground font-mono">{l.views_30d} views · {l.tag_count}/13 tags</span>
            </span>
            <ScoreBadge score={l.score} />
            <ArrowUpRight className="h-4 w-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
          </Link>
        </li>
      ))}
      {!items.length && <li className="py-4 text-sm text-muted-foreground">Nothing urgent. Nice work.</li>}
    </ol>
  </section>
);
